import React from 'react';
import { FadeIn } from './ui/FadeIn';
const problems = ['Entrenás mucho pero en los partidos importantes tu juego no aparece', 'Tu distribución es predecible y los rivales ya saben a quién vas a armar', 'Sentís que hace meses o años tu juego no da un salto real de calidad', 'No tenés un sistema claro de desarrollo, solo hacés lo que el entrenador dice ese día', 'En el momento crítico del partido la mente se bloquea y las decisiones salen mal', 'No hay material específico para armadores en español que aplique a tu realidad', 'Tu liderazgo dentro del equipo no está desarrollado y eso se nota en cancha', 'Trabajás la técnica por un lado, la táctica por otro y nunca terminan de ensamblarse'];
export const ProblemSection = () => {
  return <section className="py-12 md:py-24 bg-navy-900 relative overflow-hidden" data-id="element-389">
      <div className="absolute top-0 right-0 w-96 h-96 bg-red-500/5 blur-[120px] rounded-full pointer-events-none" data-id="element-390" />
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-391">
        <FadeIn data-id="element-392">
          <h2 className="text-3xl md:text-5xl font-bebas text-center mb-8 md:mb-16 text-white" data-id="element-393">
            Si sos armador de voleibol en Argentina,{' '}
            <br className="hidden md:block" data-id="element-394" />
            <span className="text-gold-500" data-id="element-395">esto te va a sonar familiar:</span>
          </h2>
        </FadeIn>

        <div className="space-y-2.5 md:space-y-4" data-id="element-396">
          {problems.map((problem, i) => <FadeIn key={i} delay={i * 0.05} direction="left" data-id="element-397">
              <div className="flex items-start gap-3 md:gap-4 p-3 md:p-6 bg-navy-800/50 border border-navy-700 rounded-lg hover:border-gold-500/30 transition-colors" data-id="element-398">
                <span className="text-xl md:text-3xl font-bebas text-gold-500/50 shrink-0 mt-0.5 md:mt-1" data-id="element-399">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p className="text-gray-300 text-base md:text-xl leading-relaxed" data-id="element-400">
                  — {problem}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.4} className="mt-10 md:mt-20 text-center" data-id="element-401">
          <h3 className="text-3xl md:text-6xl font-bebas text-white text-glow-gold" data-id="element-402">
            ¿Cuántos partidos más vas a jugar{' '}
            <span className="text-gold-500 border-b-4 border-gold-500" data-id="element-403">
              sin un sistema?
            </span>
          </h3>
        </FadeIn>
      </div>
    </section>;
};